import { LocalizedLink } from "@/i18n/language";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { img } from "@/lib/images";

const SLIDER_IMAGES = [
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-01.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-02.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-03.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-04.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-05.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-06.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-07.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-08.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-09.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-10.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-11.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-12.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-13.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-14.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-15.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-16.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
  { src: img("activities/adventure-tours/adventure-4/adventure-tour-4-slider-17.jpg"), alt: "Göttliches Bali – Tauchen und Kultur in Nord-Bali" },
];

const ITINERARY_ITEMS = [
  { titleKey: "adventure_4_day2_title", descKey: "adventure_4_day2_desc" },
  { titleKey: "adventure_4_day3_title", descKey: "adventure_4_day3_desc" },
  { titleKey: "adventure_4_day4_title", descKey: "adventure_4_day4_desc" },
  { titleKey: "adventure_4_day5_title", descKey: "adventure_4_day5_desc" },
  { titleKey: "adventure_4_day6_title", descKey: "adventure_4_day6_desc" },
  { titleKey: "adventure_4_day7_title", descKey: "adventure_4_day7_desc" },
  { titleKey: "adventure_4_day8_title", descKey: "adventure_4_day8_desc" },
  { titleKey: "adventure_4_day9_title", descKey: "adventure_4_day9_desc" },
];

const RELATED_TOURS = [
  {
    slug: "adventure-01",
    image: img("activities/adventure-tours/adventure-1/header-adventure-1.jpg"),
    titleKey: "adventure_1_title",
    descKey: "adventure_1_desc",
  },
  {
    slug: "adventure-02",
    image: img("activities/adventure-tours/adventure-2/header-sailing-01.jpg"),
    titleKey: "adventure_2_title",
    descKey: "adventure_2_desc",
  },
  {
    slug: "adventure-03",
    image: img("activities/adventure-tours/adventure-3/header-adventure-3.jpg"),
    titleKey: "adventure_3_title",
    descKey: "adventure_3_desc",
  },
];

export default function DivingCulturePage() {
  const { t } = useTranslation();
  const [sliderIndex, setSliderIndex] = useState(0);

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("adventure_eyebrow")}
          title={t("adventure_4_title")}
          subtitle={t("adventure_4_subtitle")}
          image={img("activities/adventure-tours/adventure-4/header-adventure-4.jpg")}
          imageAlt="Göttliches Bali"
        />

        {/* Image Gallery */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="rounded-lg overflow-hidden border border-background-200 aspect-video">
              <img
                src={SLIDER_IMAGES[sliderIndex].src}
                alt={SLIDER_IMAGES[sliderIndex].alt}
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="flex gap-2 mt-3 overflow-x-auto pb-2">
              {SLIDER_IMAGES.map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => setSliderIndex(idx)}
                  className={`w-20 h-14 rounded overflow-hidden border-2 flex-shrink-0 cursor-pointer transition-colors ${
                    sliderIndex === idx
                      ? "border-accent-500"
                      : "border-transparent hover:border-background-300"
                  }`}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="mb-8">
              <LocalizedLink
                to="/adventure-tours"
                className="inline-flex items-center gap-2 text-sm text-accent-700 hover:text-accent-900 transition-colors"
              >
                <i className="ri-arrow-left-line"></i>
                {t("tour_detail_back_adventure")}
              </LocalizedLink>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
              {/* Main content */}
              <div className="lg:col-span-2 space-y-10">
                {/* Description */}
                <div>
                  <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                    {t("tour_detail_description_label")}
                  </h2>
                  <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
                  <p className="text-foreground-700 leading-relaxed">
                    {t("adventure_4_detail")}
                  </p>
                </div>

                {/* For whom */}
                <div className="relative rounded-lg overflow-hidden">
                  <img
                    src={img("activities/adventure-tours/atventure-tours-diving-tour-01.jpg")}
                    alt="Bali Dschungel"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/70 to-foreground-950/50"></div>
                  <div className="relative p-6 md:p-8">
                    <h2 className="font-heading text-xl md:text-2xl text-background-50 mb-4">
                      {t("adventure_4_for_who_title")}
                    </h2>
                    <div className="w-10 h-0.5 bg-accent-500 mb-4"></div>
                    <p className="text-background-50/90 leading-relaxed">
                      {t("adventure_4_for_who_desc")}
                    </p>
                  </div>
                </div>

                {/* Itinerary */}
                <div>
                  <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                    {t("tour_detail_itinerary_label")}
                  </h2>
                  <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
                  <div className="space-y-3">
                    {ITINERARY_ITEMS.map((item, idx) => (
                      <div
                        key={idx}
                        className="bg-background-100 border border-background-200 rounded-lg overflow-hidden"
                      >
                        <div className="p-4 md:p-5">
                          <span className="font-heading font-bold text-base md:text-lg text-foreground-950">
                            {t(item.titleKey)}
                          </span>
                        </div>
                        <div className="px-4 md:px-5 pb-4 md:pb-5">
                          <p className="text-sm text-foreground-700 leading-relaxed">
                            {t(item.descKey)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Price & CTA */}
                <div>
                  <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                    {t("adventure_4_price_title")}
                  </h2>
                  <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
                  <div className="bg-background-100 border border-background-200 rounded-lg p-5 md:p-6">
                    <p className="text-sm text-foreground-700 leading-relaxed whitespace-pre-line mb-5">
                      {t("adventure_4_price_desc")}
                    </p>
                    <div className="flex items-center gap-3 mb-5">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                        <i className="ri-price-tag-3-line text-lg"></i>
                      </span>
                      <div>
                        <p className="text-xs text-foreground-600 uppercase tracking-wide">
                          {t("tour_detail_price_label")}
                        </p>
                        <p className="text-sm font-medium text-foreground-950">
                          {t("adventure_4_price_amount")}
                        </p>
                      </div>
                    </div>
                    <a
                      href="https://balidivecenter.com/tauchen-in-bali-buchen/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-3 rounded-md font-medium whitespace-nowrap cursor-pointer transition-colors"
                    >
                      <i className="ri-external-link-line"></i>
                      {t("adventure_4_book_link")}
                    </a>
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <div className="lg:col-span-1 space-y-6">
                <div className="bg-background-100 border border-background-200 rounded-lg p-6">
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                        <i className="ri-time-line text-lg"></i>
                      </span>
                      <div>
                        <p className="text-xs text-foreground-600 uppercase tracking-wide">
                          {t("tour_detail_duration_label")}
                        </p>
                        <p className="text-sm font-medium text-foreground-950">
                          {t("adventure_4_duration")}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                        <i className="ri-price-tag-3-line text-lg"></i>
                      </span>
                      <div>
                        <p className="text-xs text-foreground-600 uppercase tracking-wide">
                          {t("tour_detail_price_label")}
                        </p>
                        <p className="text-sm font-medium text-foreground-950">
                          {t("adventure_4_price_amount")}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                        <i className="ri-map-pin-line text-lg"></i>
                      </span>
                      <div>
                        <p className="text-xs text-foreground-600 uppercase tracking-wide">
                          {t("tour_detail_start_label")}
                        </p>
                        <p className="text-sm font-medium text-foreground-950">
                          {t("adventure_4_start_value")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Related tours */}
                <div className="bg-background-100 border border-background-200 rounded-lg p-6">
                  <h3 className="font-heading text-lg text-foreground-950 mb-4">
                    {t("tour_detail_related_label")}
                  </h3>
                  <div className="w-8 h-0.5 bg-accent-500 mb-4"></div>
                  <div className="space-y-3">
                    {RELATED_TOURS.map((rt) => (
                      <LocalizedLink
                        key={rt.slug}
                        to={`/tour/${rt.slug}`}
                        className="flex items-center gap-3 group cursor-pointer"
                      >
                        <div className="w-14 h-14 rounded-md overflow-hidden shrink-0 border border-background-200">
                          <img
                            src={rt.image}
                            alt={t(rt.titleKey)}
                            className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                          />
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-950 group-hover:text-accent-700 transition-colors">
                            {t(rt.titleKey)}
                          </p>
                          <p className="text-xs text-foreground-600">
                            {t(rt.descKey)}
                          </p>
                        </div>
                      </LocalizedLink>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}